
const Loading = () => {
  return (
    <div className="loading-overlay">
      <div className="loading-content"> 로오오딩 </div>
    </div>
  );
};

export default Loading;
